// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file channel_service.proto (package domain, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { SyncUpdate } from "./sync_update_pb";
import { file_sync_update } from "./sync_update_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file channel_service.proto.
 */
export const file_channel_service: GenFile = /*@__PURE__*/
  fileDesc("ChVjaGFubmVsX3NlcnZpY2UucHJvdG8SBmRvbWFpbiJcChRDcmVhdGVDaGFubmVsUmVxdWVzdBIPCgd1c2VyX2lkGAEgASgJEgwKBGRhdGEYAiABKAwSDwoHZXhwb3NlZBgDIAEoCBIUCgxjaGFubmVsX3R5cGUYBCABKAkiKwoVQ3JlYXRlQ2hhbm5lbFJlc3BvbnNlEhIKCmNoYW5uZWxfaWQYASABKAkiUQoTQ2xhaW1DaGFubmVsUmVxdWVzdBISCgpjaGFubmVsX2lkGAEgASgJEhgKEGF1dGhlbnRpY2F0b3JfaWQYAiABKAkSDAoEZGF0YRgDIAEoDCIkChRDbGFpbUNoYW5uZWxSZXNwb25zZRIMCgRkYXRhGAEgASgMIlUKElJlYWRDaGFubmVsUmVxdWVzdBISCgpjaGFubmVsX2lkGAEgASgJEisKCXJlY2lwaWVudBgCIAEoDjIYLmRvbWFpbi5DaGFubmVsUmVjaXBpZW50IiMKE1JlYWRDaGFubmVsUmVzcG9uc2USDAoEZGF0YRgBIAEoDCJkChNXcml0ZUNoYW5uZWxSZXF1ZXN0EhIKCmNoYW5uZWxfaWQYASABKAkSKwoJcmVjaXBpZW50GAIgASgOMhguZG9tYWluLkNoYW5uZWxSZWNpcGllbnQSDAoEZGF0YRgDIAEoDCIWChRXcml0ZUNoYW5uZWxSZXNwb25zZSIqChREZWxldGVDaGFubmVsUmVxdWVzdBISCgpjaGFubmVsX2lkGAEgASgJIkAKFURlbGV0ZUNoYW5uZWxSZXNwb25zZRInCgtzeW5jX3VwZGF0ZRgBIAEoCzISLmRvbWFpbi5TeW5jVXBkYXRlKngKEENoYW5uZWxSZWNpcGllbnQSIQodQ0hBTk5FTF9SRUNJUElFTlRfVU5TUEVDSUZJRUQQABIcChhDSEFOTkVMX1JFQ0lQSUVOVF9DTElFTlQQARIjCh9DSEFOTkVMX1JFQ0lQSUVOVF9BVVRIRU5USUNBVE9SEAIy8QIKDkNoYW5uZWxTZXJ2aWNlEkcKBkNyZWF0ZRIcLmRvbWFpbi5DcmVhdGVDaGFubmVsUmVxdWVzdBodLmRvbWFpbi5DcmVhdGVDaGFubmVsUmVzcG9uc2UiABJECgVDbGFpbRIbLmRvbWFpbi5DbGFpbUNoYW5uZWxSZXF1ZXN0GhwuZG9tYWluLkNsYWltQ2hhbm5lbFJlc3BvbnNlIgASQQoEUmVhZBIaLmRvbWFpbi5SZWFkQ2hhbm5lbFJlcXVlc3QaGy5kb21haW4uUmVhZENoYW5uZWxSZXNwb25zZSIAEkQKBVdyaXRlEhsuZG9tYWluLldyaXRlQ2hhbm5lbFJlcXVlc3QaHC5kb21haW4uV3JpdGVDaGFubmVsUmVzcG9uc2UiABJHCgZEZWxldGUSHC5kb21haW4uRGVsZXRlQ2hhbm5lbFJlcXVlc3QaHS5kb21haW4uRGVsZXRlQ2hhbm5lbFJlc3BvbnNlIgBCMFouZ2l0bGFiLmNvbS9jb3RlY2hkZS9tb25vcmVwby9iYWNrZW5kL2RvbWFpbi9wYmIGcHJvdG8z", [file_sync_update]);

/**
 * @generated from message domain.CreateChannelRequest
 */
export type CreateChannelRequest = Message<"domain.CreateChannelRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: bytes data = 2;
   */
  data: Uint8Array;

  /**
   * @generated from field: bool exposed = 3;
   */
  exposed: boolean;

  /**
   * @generated from field: string channel_type = 4;
   */
  channelType: string;
};

/**
 * Describes the message domain.CreateChannelRequest.
 * Use `create(CreateChannelRequestSchema)` to create a new message.
 */
export const CreateChannelRequestSchema: GenMessage<CreateChannelRequest> = /*@__PURE__*/
  messageDesc(file_channel_service, 0);

/**
 * @generated from message domain.CreateChannelResponse
 */
export type CreateChannelResponse = Message<"domain.CreateChannelResponse"> & {
  /**
   * @generated from field: string channel_id = 1;
   */
  channelId: string;
};

/**
 * Describes the message domain.CreateChannelResponse.
 * Use `create(CreateChannelResponseSchema)` to create a new message.
 */
export const CreateChannelResponseSchema: GenMessage<CreateChannelResponse> = /*@__PURE__*/
  messageDesc(file_channel_service, 1);

/**
 * @generated from message domain.ClaimChannelRequest
 */
export type ClaimChannelRequest = Message<"domain.ClaimChannelRequest"> & {
  /**
   * @generated from field: string channel_id = 1;
   */
  channelId: string;

  /**
   * @generated from field: string authenticator_id = 2;
   */
  authenticatorId: string;

  /**
   * @generated from field: bytes data = 3;
   */
  data: Uint8Array;
};

/**
 * Describes the message domain.ClaimChannelRequest.
 * Use `create(ClaimChannelRequestSchema)` to create a new message.
 */
export const ClaimChannelRequestSchema: GenMessage<ClaimChannelRequest> = /*@__PURE__*/
  messageDesc(file_channel_service, 2);

/**
 * @generated from message domain.ClaimChannelResponse
 */
export type ClaimChannelResponse = Message<"domain.ClaimChannelResponse"> & {
  /**
   * @generated from field: bytes data = 1;
   */
  data: Uint8Array;
};

/**
 * Describes the message domain.ClaimChannelResponse.
 * Use `create(ClaimChannelResponseSchema)` to create a new message.
 */
export const ClaimChannelResponseSchema: GenMessage<ClaimChannelResponse> = /*@__PURE__*/
  messageDesc(file_channel_service, 3);

/**
 * @generated from message domain.ReadChannelRequest
 */
export type ReadChannelRequest = Message<"domain.ReadChannelRequest"> & {
  /**
   * @generated from field: string channel_id = 1;
   */
  channelId: string;

  /**
   * @generated from field: domain.ChannelRecipient recipient = 2;
   */
  recipient: ChannelRecipient;
};

/**
 * Describes the message domain.ReadChannelRequest.
 * Use `create(ReadChannelRequestSchema)` to create a new message.
 */
export const ReadChannelRequestSchema: GenMessage<ReadChannelRequest> = /*@__PURE__*/
  messageDesc(file_channel_service, 4);

/**
 * @generated from message domain.ReadChannelResponse
 */
export type ReadChannelResponse = Message<"domain.ReadChannelResponse"> & {
  /**
   * @generated from field: bytes data = 1;
   */
  data: Uint8Array;
};

/**
 * Describes the message domain.ReadChannelResponse.
 * Use `create(ReadChannelResponseSchema)` to create a new message.
 */
export const ReadChannelResponseSchema: GenMessage<ReadChannelResponse> = /*@__PURE__*/
  messageDesc(file_channel_service, 5);

/**
 * @generated from message domain.WriteChannelRequest
 */
export type WriteChannelRequest = Message<"domain.WriteChannelRequest"> & {
  /**
   * @generated from field: string channel_id = 1;
   */
  channelId: string;

  /**
   * @generated from field: domain.ChannelRecipient recipient = 2;
   */
  recipient: ChannelRecipient;

  /**
   * @generated from field: bytes data = 3;
   */
  data: Uint8Array;
};

/**
 * Describes the message domain.WriteChannelRequest.
 * Use `create(WriteChannelRequestSchema)` to create a new message.
 */
export const WriteChannelRequestSchema: GenMessage<WriteChannelRequest> = /*@__PURE__*/
  messageDesc(file_channel_service, 6);

/**
 * empty response
 *
 * @generated from message domain.WriteChannelResponse
 */
export type WriteChannelResponse = Message<"domain.WriteChannelResponse"> & {
};

/**
 * Describes the message domain.WriteChannelResponse.
 * Use `create(WriteChannelResponseSchema)` to create a new message.
 */
export const WriteChannelResponseSchema: GenMessage<WriteChannelResponse> = /*@__PURE__*/
  messageDesc(file_channel_service, 7);

/**
 * @generated from message domain.DeleteChannelRequest
 */
export type DeleteChannelRequest = Message<"domain.DeleteChannelRequest"> & {
  /**
   * @generated from field: string channel_id = 1;
   */
  channelId: string;
};

/**
 * Describes the message domain.DeleteChannelRequest.
 * Use `create(DeleteChannelRequestSchema)` to create a new message.
 */
export const DeleteChannelRequestSchema: GenMessage<DeleteChannelRequest> = /*@__PURE__*/
  messageDesc(file_channel_service, 8);

/**
 * @generated from message domain.DeleteChannelResponse
 */
export type DeleteChannelResponse = Message<"domain.DeleteChannelResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;
};

/**
 * Describes the message domain.DeleteChannelResponse.
 * Use `create(DeleteChannelResponseSchema)` to create a new message.
 */
export const DeleteChannelResponseSchema: GenMessage<DeleteChannelResponse> = /*@__PURE__*/
  messageDesc(file_channel_service, 9);

/**
 * @generated from enum domain.ChannelRecipient
 */
export enum ChannelRecipient {
  /**
   * @generated from enum value: CHANNEL_RECIPIENT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CHANNEL_RECIPIENT_CLIENT = 1;
   */
  CLIENT = 1,

  /**
   * @generated from enum value: CHANNEL_RECIPIENT_AUTHENTICATOR = 2;
   */
  AUTHENTICATOR = 2,
}

/**
 * Describes the enum domain.ChannelRecipient.
 */
export const ChannelRecipientSchema: GenEnum<ChannelRecipient> = /*@__PURE__*/
  enumDesc(file_channel_service, 0);

/**
 * Channel operations 
 *
 * @generated from service domain.ChannelService
 */
export const ChannelService: GenService<{
  /**
   * errors:
   * - MissingCredentials (30100): exposed == false and credentials are missing
   * - InvalidCredentials (30420): the credentials provided are invalid (e.g. session was deleted)
   * - PermissionDenied (10100): exposed == false and user_id does not match token
   * - UserNotFound (20400): user not found
   * - Internal (10500): internal server error
   *
   * @generated from rpc domain.ChannelService.Create
   */
  create: {
    methodKind: "unary";
    input: typeof CreateChannelRequestSchema;
    output: typeof CreateChannelResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100): credentials are missing
   * - InvalidCredentials (30420): the credentials provided are invalid (e.g. session was deleted)
   * - AuthenticatorNotFound (40400): authenticator not found
   * - AuthenticatorChannelNotFound (40410): channel not found
   * - AuthenticatorChannelAlreadyClaimed (40411): channel was already claimed
   * - PermissionDenied (10100): channel does not belong to user
   * - Internal (10500): internal server error
   *
   * @generated from rpc domain.ChannelService.Claim
   */
  claim: {
    methodKind: "unary";
    input: typeof ClaimChannelRequestSchema;
    output: typeof ClaimChannelResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100): channel is not exposed and no valid credentials were provided
   * - InvalidCredentials (30420): the credentials provided are invalid (e.g. session was deleted)
   * - PermissionDenied (10100): channel does not belong to user
   * - InvalidRecipient (40500): invalid recipient
   * - Timeout (10200): timeout, client might retry
   * - AuthenticatorChannelNotFound (40410): channel not found
   * - Internal (10500): internal server error
   *
   * @generated from rpc domain.ChannelService.Read
   */
  read: {
    methodKind: "unary";
    input: typeof ReadChannelRequestSchema;
    output: typeof ReadChannelResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100): channel is not exposed and no valid credentials were provided
   * - InvalidCredentials (30420): the credentials provided are invalid (e.g. session was deleted)
   * - PermissionDenied (10100): channel does not belong to user
   * - InvalidRecipient (40500): invalid recipient
   * - AuthenticatorChannelNotFound (40410): channel not found
   * - Internal (10500): internal server error
   *
   * @generated from rpc domain.ChannelService.Write
   */
  write: {
    methodKind: "unary";
    input: typeof WriteChannelRequestSchema;
    output: typeof WriteChannelResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100): channel is not exposed and no valid credentials were provided
   * - InvalidCredentials (30420): the credentials provided are invalid (e.g. session was deleted)
   * - PermissionDenied (10100): channel does not belong to user
   * - AuthenticatorChannelNotFound (40410): channel not found
   * - Internal (10500)(10500): internal server error
   *
   * @generated from rpc domain.ChannelService.Delete
   */
  delete: {
    methodKind: "unary";
    input: typeof DeleteChannelRequestSchema;
    output: typeof DeleteChannelResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_channel_service, 0);

